import { Grid, Typography, Box, Button } from '@mui/material';
import React from 'react';
import { motion } from 'framer-motion';
import image from '../images/ABOUT US.png';

const About = () => {
  return (
    <Grid
      container
      sx={{
        minHeight: { md: '70vh', xs: 'auto' },
        padding: { xs: 4, md: 8 },
        alignItems: 'center',
        background: 'var(--background-light)',
      }}
    >
      {/* Image Section */}
      <Grid
        item
        xs={12}
        md={5}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative'
        }}
      >
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center' }}
        >
          {/* Decorative background shape */}
          <Box sx={{
            position: 'absolute',
            width: '80%',
            height: '90%',
            backgroundColor: 'var(--secondary-light)',
            borderRadius: '24px',
            transform: 'rotate(-5deg)',
            zIndex: 0,
            opacity: 0.2
          }} />

          <img
            src={image}
            alt="PU Colleges"
            style={{
              width: '85%',
              height: 'auto',
              borderRadius: '24px',
              boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
              zIndex: 1,
              position: 'relative'
            }}
          />
        </motion.div>
      </Grid>

      {/* Text Section */}
      <Grid
        item
        xs={12}
        md={7}
        sx={{
          color: 'var(--text-primary)',
          textAlign: { xs: 'center', md: 'left' },
          pl: { md: 8 },
          pt: { xs: 6, md: 0 }
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <Typography
            variant="overline"
            sx={{ color: 'var(--secondary-color)', fontWeight: 700, letterSpacing: '2px', mb: 1, display: 'block' }}
          >
            DISCOVER EXCELLENCE
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 800,
              marginBottom: 3,
              color: 'var(--primary-color)',
              fontSize: { xs: '32px', md: '44px' },
              letterSpacing: '-1px'
            }}
          >
            About Our PU Colleges
          </Typography>

          <Box sx={{ width: '60px', height: '4px', backgroundColor: 'var(--secondary-color)', mb: 4, mx: { xs: 'auto', md: 0 }, borderRadius: '2px' }} />

          <Typography
            variant="body1"
            sx={{
              lineHeight: 1.8,
              fontSize: { xs: '16px', md: '18px' },
              color: 'var(--text-secondary)',
              mb: 4
            }}
          >
            Some of the best Pre-University (PU) institutes provide students with a solid basis for their academic and professional goals. These universities are well known for their first-rate facilities, dedicated faculty, and comprehensive approach to learning.
            <br /><br />
            These schools educate students for competitive exams and life after school by emphasizing academics, extracurricular activities, and personal growth.
          </Typography>

          <Button
            variant="contained"
            sx={{
              backgroundColor: 'var(--primary-color)',
              color: '#fff',
              textTransform: 'none',
              fontSize: { xs: '16px', md: '18px' },
              fontWeight: 600,
              borderRadius: '30px',
              padding: '12px 32px',
              boxShadow: '0 8px 16px rgba(26,35,126,0.3)',
              '&:hover': {
                backgroundColor: 'var(--primary-light)',
                transform: 'translateY(-2px)',
                boxShadow: '0 12px 20px rgba(26,35,126,0.4)',
              },
              transition: 'all 0.3s ease'
            }}
            onClick={() =>
              window.location.href = 'https://www.getmycollege.com/colleges/top-pu-colleges-in-bangalore'
            }
          >
            Explore Programs
          </Button>
        </motion.div>
      </Grid>
    </Grid>
  );
};

export default About;
